"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.extractChildren = extractChildren;
exports.warnOfPropErrors = warnOfPropErrors;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _react = _interopRequireDefault(require("react"));

var _Panel = _interopRequireDefault(require("./Panel"));

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function extractChildren(children, types) {
  var _children = [];
  var components = {};

  if ((0, _isArray["default"])(types)) {
    _react["default"].Children.toArray(children).forEach(function (child) {
      if (child.type && types.includes(child.type.displayName)) {
        if (Object.prototype.hasOwnProperty.call(components, child.type.displayName)) {
          var childs = (0, _isArray["default"])(components[child.type.displayName]) ? [child].concat((0, _toConsumableArray2["default"])(components[child.type.displayName])) : [child, components[child.type.displayName]];
          components[child.type.displayName] = childs;
        } else {
          components[child.type.displayName] = child;
        }
      } else {
        _children.push(child);
      }
    });

    return _objectSpread(_objectSpread({}, components), {}, {
      children: _children
    });
  }

  throw new Error("extractChildren types parameter must be an Array");
}

function warnOfPropErrors(props) {
  var wrongProps = [];
  /* eslint-disable no-unused-expressions */

  switch (props.slideFrom) {
    case types.slideFroms.LEFT:
    case types.slideFroms.RIGHT:
      props.height !== _Panel["default"].defaultProps.height && wrongProps.push("height");
      props.offset.left && wrongProps.push("offset.left");
      props.offset.right && wrongProps.push("offset.right");
      break;

    case types.slideFroms.BOTTOM:
      props.width !== _Panel["default"].defaultProps.width && wrongProps.push("width");
      props.offset.top && wrongProps.push("offset.top");
      break;

    default:
  }
  /* eslint-enable no-unused-expressions */


  wrongProps.forEach(function (wrongProp) {
    console.warn("The \"".concat(wrongProp, "\" prop is ignored by the @paprika/").concat(_Panel["default"].displayName, " component when \"slideFrom\" is ").concat(props.slideFrom, "."));
  });
}
//# sourceMappingURL=helpers.js.map